import React, { useRef, useState } from 'react';
import { Loader } from '../Loader/Loader';
import { ReactComponent as UploadFileIcon } from '@/assets/img/upload-pet-image.svg';

const HybridFileUploader: React.FC<{
  onFileSelect: (file: File) => void;
  isLoading: boolean;
  onlyFile: boolean;
  fuLabel: string;
  showLoader?: boolean;
  disabled?: boolean;
  validateFile: (file: File) => boolean;
}> = ({ onFileSelect, isLoading, onlyFile, fuLabel, showLoader, validateFile, disabled }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragActive, setDragActive] = useState(false);

  const _validateFile = (file: File) => {
    if (validateFile(file)) return true;

    if (inputRef && inputRef.current) inputRef.current.value = '';
    return false;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && _validateFile(file)) {
      onFileSelect(file);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files?.[0];
    if (file && _validateFile(file)) {
      onFileSelect(file);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const openFileDialog = () => {
    inputRef.current?.click();
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onClick={openFileDialog}
      className={`file-upload ${disabled ? 'disabled' : ''}`}
      key={fuLabel}
    >
      {showLoader && isLoading ? (
        <Loader text="uploading..." />
      ) : onlyFile ? (
        <>
          <UploadFileIcon />
          <p>
            Drag & drop or <span>choose files</span> to upload
          </p>
          <p>
            Only files of max <b>10MB</b> size allowed
          </p>
        </>
      ) : (
        <>
          <p>
            Use <span>camera</span> to capture the image and upload
          </p>
        </>
      )}

      <input
        ref={inputRef}
        type="file"
        disabled={disabled}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default HybridFileUploader;
